export default function ({ store }) {
  console.log('판매알림신청 초기화 플러그인 실행')

  // 로그인 상태 확인 후 판매알림신청 목록 로드
  const checkAndLoadAnc = () => {
    const mbMngNo = store.getters['session/getMbMngNo']
    if (mbMngNo && mbMngNo !== 'undefined' && mbMngNo !== '') {
      store.dispatch('anc/fetchAncList')
    } else {
      console.log('로그인되지 않아 판매알림신청 목록 로드 건너뜀')
    }
  }

  // 초기 로드
  checkAndLoadAnc()

  // 포커스 시 갱신
  window.addEventListener('focus', checkAndLoadAnc)

  // mbMngNo 변경 감지 (로그인/로그아웃)
  store.watch(
    state => state.session.member.mbMngNo,
    (newMbMngNo, oldMbMngNo) => {
      if (newMbMngNo !== oldMbMngNo) {
        console.log('mbMngNo 변경 감지, 판매알림신청 목록 갱신/초기화')
        store.dispatch('anc/fetchAncList')

        // [DRNQ-2868] 사용자 변경 시 기획전 신청 상태 초기화
        store.commit('curation/CLEAR_APPLIED_STATES')
      }
    }
  )
}
